// extracted by mini-css-extract-plugin
export default {"modal":"legacy_modal-module___modal___cfc3914b"};